// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  agentId: __t.u64().primaryKey().name("agent_id"),
  workspaceId: __t.u64().name("workspace_id"),
  seatKey: __t.string().name("seat_key"),
  status: __t.string(),
  updatedAt: __t.i64().name("updated_at"),
});
